import { IconCategoryData, IconUiCategory } from './iconToolTypes';

export const RECOMMENDED_CATEGORY: IconCategoryData = { slug: IconUiCategory.DEFAULT, title: 'Recommended' };
export const LETTERS_CATEGORY: IconCategoryData = { slug: IconUiCategory.LETTERS, title: 'Letters & numbers' };
